module.exports = __webpack_public_path__ + "static/media/addCircle.03634e41.svg";